// extracted by mini-css-extract-plugin
module.exports = {"reportsPage":"uMAYO"};